export default __webpack_public_path__ + "static/media/BlendEspresso.6ff9b0d0.png";